import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FloatLabelType } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs';
import { Roles } from 'src/app/layouts/full/shared/Enums';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { Card } from 'src/app/models/card.model';
import { Scan, ScanFile } from 'src/app/models/scan.model';
import { AddressList } from 'src/app/models/status.model';
import { AccountSettingService } from 'src/app/services/account-settings.service';
import { CardService } from 'src/app/services/card.service';
import { CommonService } from 'src/app/services/common.service';
import { ScanService } from 'src/app/services/scan.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-order-create-design-engine',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './order-create-design-engine.component.html',
  styleUrl: './order-create-design-engine.component.scss',
  providers: [MessageService],
})
export class OrderCreateDesignEngineComponent {
  selectedRows: Scan[] = [];
  cards: Card[] = [];
  addressList: AddressList[] = [];
  notes: string = '';
  selectedShippingAddressId: string;
  selectedBillingAddressId: string;
  selectedCardId: string;
  customerValue: string;
  isAddressesPopup: boolean = false;
  addressForm: FormGroup;
  countryList = [];
  basePrice: number = 24;
  pricePerFinishing: number = 10;
  selectedFiles: any[] = [];
  selectedShippingMethod: any;
  totalAmount: number = 0;
  form: FormGroup;

  topCovers: { value: number, name: string }[] = [
    {
      value: 44,
      name: "EVA - Black"
    },
    {
      value: 46,
      name: "Black watter pattern"
    },
    {
      value: 37,
      name: "EVA - Grey"
    },
    {
      value: 33,
      name: "Faux Leather - Black"
    },
    {
      value: 55,
      name: "Neoprene - Black 3mm"
    },
    {
      value: 36,
      name: "EVA - Sand Perforated"
    },
    {
      value: 56,
      name: "Neoprene - Black 1.5mm"
    },
    {
      value: 45,
      name: "EVA - Ocean Blue Pattern"
    },
    {
      value: 43,
      name: "EVA - Sky Blue Perforated"
    },
    {
      value: 32,
      name: "Faux Leather - Dark Brown"
    }
  ];

  bottomCovers: { value: number, name: string }[] = [
    {
      value: 90,
      name: "Unlined"
    },
    {
      value: 49,
      name: "EVA - Black 1mm"
    },
    {
      value: 53,
      name: "Microfiber - Black"
    },
    {
      value: 33,
      name: "Synthetic Leather - Black"
    },
    {
      value: 46,
      name: "EVA - Black watter pattern"
    }
  ]


  productFinishingForm = new FormGroup({
    finishings: new FormControl(false, [Validators.required]),
    topCover: new FormControl('', [Validators.required]),
    bottomCover: new FormControl('')
  });

  constructor(private activatedRoute: ActivatedRoute,
    private cardService: CardService,
    private addresService: AccountSettingService,
    private scanService: ScanService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private commonService: CommonService,
    private router: Router,
    private userService: UserService,
    private cdRef: ChangeDetectorRef) {
    const state = history.state;

    if (state && state.selectedRows) {
      this.selectedRows = state.selectedRows;
    }
  }

  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto' as FloatLabelType);
  options

  ngOnInit(): void {
    this.getCards();
    this.getAllAddress();
    this.addressFormBuild();

    // Check role to change the prices on products
    if (this.userService.user.role === Roles.ROLE_INDIVIDUAL_CLIENT) {
      this.basePrice = 27.5;
    }

    this.form = this.fb.group({
      selectedCardId: [null] // Use an initial value if needed
    });

    this.countryList = this.commonService.countryList;

    this.selectedRows.forEach(scan => {
      scan.files.forEach(file => {
        // select all the files
        if (file.type == "stl" && file.name.includes("design_insole")) {
          this.toggleFileSelection(file);

          if (!file.quantity) {
            file.quantity = 1;
          }
        }
      });
    });

    this.options = this.fb.group({
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
    });
  }

  getFloatLabelValue(): FloatLabelType {
    return this.floatLabelControl.value || 'auto';
  }

  updateSelectedCardId(cardId: string) {
    // Ensure that the form is initialized
    if (!this.form) {
      return;
    }

    // Update the selectedCardId in the form
    this.form.get('selectedCardId').patchValue(cardId);
  }


  hasDesignInsolesFiles(files: ScanFile[]): boolean {
    return files.some(file => file.type === 'stl' && file.name.includes('design_insole'));
  }

  getCards() {
    this.cardService.list().subscribe((cards) => {
      this.cards = cards;
    })
  }

  getAllAddress() {
    this.addresService.getAllAddress().subscribe((res: AddressList[]) => {
      this.addressList = res;
    })
  }

  getSelectedAddress(addressId: string) {
    // Find the selected address based on the addressId
    return this.addressList.find((address: any) => address.ID === addressId);
  }

  getAddressData(address: AddressList | undefined) {
    if (!address) return null;

    return {
      country: address.country,
      contactNameAndSurname: address.contactNameAndSurname,
      phoneNumber: address.phoneNumber,
      streetNameAndNumber: address.streetNameAndNumber,
      apartmentOrOthers: address.apartmentOrOthers,
      city: address.city,
      postalCode: address.postalCode,
      province: address.province,
      default: address.default
    };
  }

  redirectToOrderList() {
    this.router.navigate(['/list-order-design-engine']);
  }

  createOrder() {
    // Check if selectedCardId is available
    if (!this.form.get('selectedCardId').value) {
      Swal.fire("Payment method", "Please select your payment method", "warning")
      return;
    }

    // Check if all the top/bottom covers are selected
    let missingTopBottomCover = false;
    for (const order of this.selectedRows) {
      if (order.productFinished && (!order.bottomCover || !order.topCover)) {
        missingTopBottomCover = true;
        Swal.fire("Missing required field", "Some of the orders is missing top or bottom cover", "warning")
        break;
      }
    }

    if (missingTopBottomCover) {
      return;
    }


    const orderRows = this.selectedRows.map(item => {

      const result = {
        scanId: item.ID,
        patient: {
          name: item.data['Patient Data'].name || "",
          surname: item.data['Patient Data'].surname || " ",
          weight: item.data['Patient Data'].weight || 70,
          shoeSize: item.data['Patient Data'].shoeSize || 0,
          birthDate: item.data['Patient Data'].birthDate || "2000-01-01",
          gender: item.data['Patient Data'].sex === "Male" ? "m" : "f"
        },
        files: item.files.filter(file => file.type === 'stl' && file.selected).map(file => ({
          url: file.path,
          quantity: file.quantity
        }))
      };

      // Add these properties only if exists
      ['productFinished', 'topCover', 'bottomCover'].forEach(prop => {
        if (item[prop]) {
          result[prop] = item[prop];
        }
      });

      return result;
    });



    const orderId = uuidv4();

    const billingAddress = this.getSelectedAddress(this.selectedBillingAddressId);
    const shippingAddress = this.getSelectedAddress(this.selectedShippingAddressId);


    if (!billingAddress || !shippingAddress) {
      Swal.fire("Address", "Please select your billing and shipping address", "warning")
      return;
    }

    if (!this.selectedShippingMethod) {
      Swal.fire("Shipping Method", "Please select your shipping method", "warning")
      return;
    }

    const selectedCard = this.cards.find(card => card.id === this.form.get('selectedCardId').value);
    this.customerValue = selectedCard?.customer || '';

    const payload = {
      notes: this.notes,
      cardId: this.form.get('selectedCardId').value,
      stripeCustomerId: this.customerValue,
      orderId: orderId,
      orderRows: orderRows,
      billingAddress: this.getAddressData(billingAddress),
      shippingAddress: this.getAddressData(shippingAddress),
      paymentMethod: "Card",
      deliveryMethod: this.selectedShippingMethod.type,
      printingHubClientCode: this.userService.user.printingHubClientCode
    };

    Swal.showLoading();

    this.scanService.createOrder(payload)
      .pipe(
        finalize(() => {
          // Reset values after successful order creation or if there's an error
          this.resetValues();
        })
      )
      .subscribe(
        (res) => {
          console.log("CREATE_ORDER", res);
          Swal.close();
          this.router.navigate(['/dashboard']);
        }, (err) => {

        }
      );
  }

  resetValues() {
    this.selectedBillingAddressId = null;
    this.selectedShippingAddressId = null;
    this.selectedCardId = null;
    this.notes = '';
    this.customerValue = null;
  }


  showAddressDialog() {
    this.isAddressesPopup = !this.isAddressesPopup
  }

  addressFormBuild(): void {
    this.addressForm = this.fb.group({
      country: ['', [Validators.required]],
      name: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      address: ['', [Validators.required]],
      basicAddress: [''],
      pincode: ['', [Validators.required, Validators.minLength(6)]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      default: [false, [Validators.required]],
    })
  }

  submit() {
    this.isAddressesPopup = false
    const payload = {
      country: this.addressForm.value.country.name,
      contactNameAndSurname: this.addressForm.value.name,
      phoneNumber: this.addressForm.value.phone,
      streetNameAndNumber: this.addressForm.value.basicAddress,
      apartmentOrOthers: this.addressForm.value.address,
      postalCode: this.addressForm.value.pincode.toString(),
      city: this.addressForm.value.city,
      province: this.addressForm.value.state,
      default: this.addressForm.value.default ? true : false
    }

    if (!this.addressForm.valid) {
      Swal.fire("Address", "Please fill all the required fields", "warning")
      return null;
    } else {
      this.addresService.addAddress(payload).subscribe({
        next: (res) => {
          this.addressForm.reset();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address added successfully..' });
          this.getAllAddress()
        },
        error: (err) => {
          this.addressForm.reset();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        }
      })
    }
  }

  incrementFileCount(file: ScanFile) {
    if (!file.quantity) {
      file.quantity = 1;
    }
    file.quantity++;
    this.updateTotalAmount();
  }

  decrementFileCount(file: ScanFile) {
    if (!file.quantity) {
      file.quantity = 1;
    }
    if (file.quantity > 1) {
      file.quantity--;
      this.updateTotalAmount();
    }
  }

  calculatePrice(file: ScanFile): number {
    const scan = this.selectedRows.find((scan) => scan.ID === file.name.split("_")[0]);

    let totalPrice = this.basePrice * (file.quantity || 1)

    if (scan.productFinished) {
      totalPrice += this.pricePerFinishing * (file.quantity || 1)
    }

    return totalPrice;
  }

  // Function to handle file selection
  selectShippingMethod(method: { type: string, cost: number }) {
    this.selectedShippingMethod = method;
    this.updateTotalAmount();
  }


  // Function to handle file selection
  toggleFileSelection(file: ScanFile) {
    const index = this.selectedFiles.findIndex(selectedFile => this.areFilesEqual(selectedFile, file));

    if (index !== -1) {
      file.selected = false;
      this.selectedFiles.splice(index, 1);
    } else {
      file.selected = true;
      this.selectedFiles.push(file);
    }

    this.updateTotalAmount();
  }

  // Function to check if two files are equal
  areFilesEqual(file1: ScanFile, file2: ScanFile): boolean {
    // Implement your logic to compare files, for example, based on file properties like name
    return file1.name === file2.name && file1.type === file2.type;
  }

  // Function to check if a file is selected
  isSelectedFile(file: ScanFile): boolean {
    return this.selectedFiles.some(selectedFile => this.areFilesEqual(selectedFile, file));
  }

  // Function to calculate and update the total amount
  updateTotalAmount() {
    // Calculate total amount based on selected files and shipping method
    let filesTotal = 0;
    for (const file of this.selectedFiles) {
      filesTotal += this.calculatePrice(file);
    }

    const shippingCost = this.selectedShippingMethod ? this.selectedShippingMethod.cost : 0;

    this.totalAmount = filesTotal + shippingCost;
  }

  getCardImage(brand: string): string {
    // Map the card brand to the corresponding image file name
    const brandToImageMap = {
      'Visa': 'visa-inc.png',
      'AmericanExpress': 'american-express.png',
      'DinersClub': 'diners-club.png',
      'Discover': 'discover.png',
      'JCB': 'jcb.png',
      'MasterCard': 'mastercard.png',
      'EftposAustralia': 'EFTPOS-02.jpg',
      'Unionpay': 'union-pay-02.png'
    };

    // Get the image file name based on the card brand
    const imageName = brandToImageMap[brand] || 'default-card.png';

    // Return the full image path
    return `../../../assets/images/${imageName}`;
  }
}
